// German for the client's contacts & record surface. Registered on load.
import { registerDe } from '../i18n/index.js';

registerDe({
  'Logo': 'Logo',
  'The deck cover lockup renders it as «logo × NAVEN».': 'Das Deck-Cover-Lockup zeigt es als «Logo × NAVEN».',
  'no logo on the record': 'kein Logo im Record',
  'Replace logo…': 'Logo ersetzen…',
  'Upload logo…': 'Logo hochladen…',
  'Remove': 'Entfernen',
  'Logo saved — the deck cover uses it.': 'Logo gespeichert — das Deck-Cover verwendet es.',
  'Client saved': 'Kunde gespeichert',
  'A first or family name is required': 'Vor- oder Nachname ist erforderlich',
  'Contact saved': 'Kontakt gespeichert',
  'Client archived — it keeps its history and leaves the active list': 'Kunde archiviert — er behält seine Historie und verlässt die aktive Liste',
  '{label} deleted — {cascade} went with it': '{label} gelöscht — {cascade} mit entfernt',
  'nothing else': 'nichts weiter',
  '{label} deleted': '{label} gelöscht',
  'Contacts': 'Kontakte',
  'Add contact': 'Kontakt hinzufügen',
  'Name': 'Name',
  'Role': 'Rolle',
  'Email': 'E-Mail',
  'Phone': 'Telefon',
  'Sponsor': 'Sponsor',
  'sponsor': 'Sponsor',
  'Edit': 'Bearbeiten',
  'Delete {name}': '{name} löschen',
  'No contacts — gate G0 needs at least one.': 'Keine Kontakte — Gate G0 braucht mindestens einen.',
  'Record': 'Datensatz',
  'Short name': 'Kurzname',
  'Sector': 'Branche',
  'Every engagement of this client inherits it; an engagement may change its own.': 'Jeder Auftrag dieses Kunden übernimmt sie; ein Auftrag kann seine eigene ändern.',
  'Correspondence language': 'Korrespondenzsprache',
  'Status': 'Status',
  'active': 'aktiv',
  'archived': 'archiviert',
  'Legal entity': 'Rechtsträger',
  'e.g. {name} Holdings Limited — the party that signs': 'z. B. {name} Holding AG — die unterzeichnende Partei',
  'Printed on the SOW as the contracting party. Leave empty if it is the same as the name above.': 'Erscheint auf der Leistungsbeschreibung (SOW) als Vertragspartei. Leer lassen, wenn identisch mit dem Namen oben.',
  'Address line 1': 'Adresszeile 1',
  'Building or house': 'Gebäude oder Haus',
  'Address line 2': 'Adresszeile 2',
  'Street': 'Strasse',
  'Post code': 'PLZ',
  'City': 'Ort',
  'Country': 'Land',
  'Notes': 'Notizen',
  'Saving…': 'Wird gespeichert…',
  'Save changes': 'Änderungen speichern',
  'Keeps every engagement, contact and document; the client leaves the active list': 'Behält jeden Auftrag, Kontakt und jedes Dokument; der Kunde verlässt die aktive Liste',
  'Archived': 'Archiviert',
  'Archive': 'Archivieren',
  'Created this by mistake? Deleting removes the client and everything under it — engagements, contacts, portal users — immediately and for good.': 'Versehentlich angelegt? Löschen entfernt den Kunden und alles darunter — Aufträge, Kontakte, Portal-Benutzer — sofort und endgültig.',
  'Delete client': 'Kunde löschen',
  'Edit contact': 'Kontakt bearbeiten',
  'New contact': 'Neuer Kontakt',
  'First name': 'Vorname',
  'Family name': 'Nachname',
  'e.g. 079 411 55 35': 'z. B. 079 411 55 35',
  'e.g. +41 79 411 55 35': 'z. B. +41 79 411 55 35',
  'Stored in international format.': 'Wird im internationalen Format gespeichert.',
  'Sponsor — signs the SOW and acceptance records': 'Sponsor — unterzeichnet SOW und Abnahmeprotokolle',
  'Cancel': 'Abbrechen',
  'Save contact': 'Kontakt speichern',
  'Archive client': 'Kunde archivieren',
  '{label} cannot be deleted': '{label} kann nicht gelöscht werden',
  'Delete {label}': '{label} löschen',
  'contact': 'Kontakt',
  'Archive instead': 'Stattdessen archivieren',
  'Got it': 'Verstanden',
  'Deleting…': 'Wird gelöscht…',
  'Delete permanently': 'Endgültig löschen',
  'Archive “{label}”? Engagements and history are preserved — the client simply drops out of the active list. Nothing is removed, and you can bring it back by setting the status to active.': '«{label}» archivieren? Aufträge und Historie bleiben erhalten — der Kunde fällt lediglich aus der aktiven Liste. Nichts wird entfernt, und Sie können ihn zurückholen, indem Sie den Status auf aktiv setzen.',
  'Delete “{label}” outright? This is for a client that should never have existed — a real one that has finished gets archived instead.': '«{label}» endgültig löschen? Das ist für einen Kunden, den es nie hätte geben sollen — ein echter, abgeschlossener wird stattdessen archiviert.',
  '{count} {what} go with it': '{count} {what} werden mit entfernt',
  'Nothing else hangs off this client.': 'Nichts weiter hängt an diesem Kunden.',
  'Including {codes} with every requirement and run inside them — and the client’s document library, stored files included.': 'Einschliesslich {codes} mit allen Anforderungen und Läufen darin — und der Dokumentbibliothek des Kunden, gespeicherte Dateien inbegriffen.',
  'Immediate and irreversible. The audit log keeps the record.': 'Sofort und unwiderruflich. Der Prüfpfad behält den Eintrag.',
  'Delete “{label}”? The full record is written to the audit log before removal.': '«{label}» löschen? Der vollständige Datensatz wird vor dem Entfernen in den Prüfpfad geschrieben.',
}, 'ClientContactsRecord');
